const SESSION_KEY = 'psp_candidate_session';

export const getCandidateToken = () => {
    try {
        const session = JSON.parse(localStorage.getItem(SESSION_KEY));
        return session && session.token ? session.token : null;
    } catch (e) {
        return null;
    }
};

export const setCandidateToken = (token) => {
    localStorage.setItem(SESSION_KEY, JSON.stringify({ token }));
};

export const clearCandidateSession = () => {
    localStorage.removeItem(SESSION_KEY);
};
